<div [attr.app-version]="version">
  <router-outlet></router-outlet>
</div>